// extracted by mini-css-extract-plugin
export default {"error":"styles_error__tjt4B","alignLeft":"styles_alignLeft__-tkYn"};